module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orders.orders !== null && Object.keys(_vm.orders.orders).length > 0) ? _c('div', [_vm._l((_vm.orders.orders), function(order, i) {
    return _c('section', {
      key: i,
      staticClass: "c-card--orders__single"
    }, [(order.source == 'Catalog') ? _c('cat-order-card', {
      attrs: {
        "order": order
      }
    }) : _c('ro-order-card', {
      attrs: {
        "order": order
      }
    })], 1)
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "pagination": _vm.getPagination,
      "pagingCallback": _vm.fetchOrderCallback
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eedecae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/OrderList.vue
// module id = 567
// module chunks = 1